import { Checkbox, FormControl, ListItemText, MenuItem, Select } from "@mui/material";

export default function BuyManagerSelector ({buyManagers, selectedBuyManagers, setSelectedBuyManagers,userId}) {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value[value.length - 1] === 'showAll') {
      // If 'showAll' is the last item, clear other selections
      setSelectedBuyManagers(['showAll']);
    } else if (value[0] === 'showAll' && value.length > 1) {
      // If 'showAll' is the first item and there are other selections, remove 'showAll'
      setSelectedBuyManagers(value.slice(1));
    } else if (value.length === 0) {
      // If the array is empty, default to 'Show All'
      setSelectedBuyManagers(['showAll']);
    } else {
      setSelectedBuyManagers(value);
    }
  };

  return(
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectedBuyManagers}
          onChange={handleChange}
          renderValue={(selectedIds) => {
            if (selectedIds.includes('showAll')) {
              return 'Show All';
            }
            const selectedBMs = buyManagers.filter(BM => selectedIds.includes(BM.buyManagerID));
            return selectedBMs.map(BM => `${BM.firstName} ${BM.lastName}`).join(', ');
          }}
          sx={{width:"300px", height:"2em", backgroundColor:"white"}}
        >
          <MenuItem key="showAll" value="showAll">
            <Checkbox checked={selectedBuyManagers.includes('showAll')} />
            <ListItemText primary="Show All" />
          </MenuItem>
          {buyManagers?.map((BM) => (
            <MenuItem key={BM.buyManagerID} value={BM.buyManagerID}>
              <Checkbox checked={selectedBuyManagers.includes(BM.buyManagerID)}/>
              <ListItemText 
                primary={
                  BM.encoreHiveId == userId
                  ? "Show Mine"
                  : BM?.firstName + " " + BM?.lastName
                }
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}